module.exports = __webpack_public_path__ + "static/media/user.28c7adff.jpg";